export const en = {
    title: 'Select users',
    info: 'The travel policy of this group will apply to all users added to the group',
    confirmation_title: 'Replace the travel policy',
    confirmation_info: 'For some users, a travel policy or group has already been selected. Do you want to replace them with a new one?',
};
